/**
 * Edilmind brand logo — E+M monogram inside a navy semi-circle frame.
 * Minimal geometry, navy + warm orange accent. Scalable, monochrome-safe.
 */
const EdilmindLogo = ({ size = 36, withMark = true, monochrome = false }) => {
  const navy = monochrome ? "currentColor" : "#0A2540";
  const orange = monochrome ? "currentColor" : "#F97316";
  const ivory = monochrome ? "currentColor" : "#FFFFFF";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      role="img"
      aria-label="Edilmind"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer disc */}
      <circle cx="24" cy="24" r="22" fill={navy} />

      {/* Inner semi-arc accent (right half) in orange */}
      <path
        d="M 24 6
           A 18 18 0 0 1 24 42
           Z"
        fill={orange}
        opacity="0.95"
      />

      {/* E (left, ivory) */}
      <g fill={ivory}>
        <rect x="13" y="14" width="3.4" height="20" rx="0.6" />
        <rect x="13" y="14" width="10" height="3.4" rx="0.6" />
        <rect x="13" y="22.4" width="8" height="3.2" rx="0.6" />
        <rect x="13" y="30.6" width="10" height="3.4" rx="0.6" />
      </g>

      {/* M (right, navy on the orange half) */}
      {withMark && (
        <g fill={navy}>
          <rect x="26.4" y="14" width="3.2" height="20" rx="0.6" />
          <rect x="33.4" y="14" width="3.2" height="20" rx="0.6" />
          {/* M valley */}
          <polygon points="29.6,14 33.4,14 31.5,22 " />
        </g>
      )}
    </svg>
  );
};

export default EdilmindLogo;
